export enum ANALYTICS_EVENTS {
  LOGIN_SUCCESS = 'login_success',
  LOGIN_FAILURE = 'login_failure',
  LOGIN_USER_NOT_APPROVED = 'login_user_not_approved'
}
